import React, { useEffect, useState, ReactNode, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import Color from '@tool/color';
import moSkin from '@store/skin';
import Service from '@service/index';

interface IProps {
  children: ReactNode,
  topRight?: ReactNode,
  isAgreement?: boolean,
}
interface IState {}

const DButton = styled(Button)(() => ({
  fontSize: '16px',
  color: Color.c55,
}));

const EButton = styled(Button)(() => ({
  padding: 0,
  marginLeft: '6px',
  fontSize: '12px',
  color: Color.c55Color(0.5),

  '&:hover': { backgroundColor: Color.blackColor(0) },
}));

const LinkButton = styled(Button)(() => ({
  margin: 0,
  padding: 0,
  fontSize: '12px',
  fontWeight: 400,
}));

const AccountLogin = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { children, topRight, isAgreement } = props;
  const { logo1, partner, copyright } = moSkin;
  // const [partner, setPartner] = useState<string>('');

  useEffect(() => {
    const init = async () => {
      const res = await Service.getSkin();
      // (document.getElementById('footer') as any).innerHTML = res.footerHtml;
      const doc: any = document;
      console.log('doc -- ', doc);
      const link = doc.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('type', 'text/css');
      link.setAttribute('href', res.footerCss);
      const falink = doc.createElement('link');
      falink.setAttribute('rel', 'icon');
      falink.setAttribute('href', res.favicon);
      const heads = doc.getElementsByTagName('head');
      for (let i = 0; i < res?.scripts?.length; i++) {
        const bdlink = doc.createElement('script');
        bdlink.setAttribute('type', 'text/javascript');
        bdlink.setAttribute('charset', 'utf-8');
        bdlink.setAttribute('src', res.scripts[i]);
        if (heads.length > 0) {
          heads[0].appendChild(bdlink);
        } else { doc.documentElement.appendChild(bdlink); }
      }

      if (heads.length > 0) {
        heads[0].appendChild(link);
      } else { doc.documentElement.appendChild(link); }
      if (heads.length > 0) {
        heads[0].appendChild(falink);
      } else { doc.documentElement.appendChild(falink); }
    };
    setTimeout(() => { init(); }, 500);

    return () => {};
  }, []);

  const backHome = () => { window.location.href = '/'; };

  const toMitt = () => { window.open('https://beian.miit.gov.cn/'); };

  const onNothing = (ev: MouseEvent) => {
    // ev.stopPropagation();
  };

  const onAgreement = () => { window.open('/agreement'); };

  return (
    <section className="login-100" id="login100">
      <section className="line-11019">
        <img src={logo1} alt="logo" onClick={backHome} />
        {topRight ? topRight : <DButton onClick={backHome}>返回首页</DButton>}
      </section>
      <section className="login-55">
        <section className="login-150" onClick={onNothing}>{children}</section>
        {(isAgreement && partner === 'smartsalary' ) ? (
          <p className="line-1110">
            <span>注册即代表同意并接受</span>
            <LinkButton onClick={onAgreement}>《用户服务协议》</LinkButton>
          </p>
        ) : null}
      </section>
      {partner === 'smartsalary' ? (
        <p className="line-11021">
          Copyright © 2017-2022 薪郅互联网科技（上海）有限公司 版权所有
          <EButton onClick={toMitt}>沪ICP备18013079号-2</EButton>
        </p>
      ) : (
        <p className="line-11021">
          {copyright.map((text: any, index: number) => (
            <span key={index}>&nbsp;{text}</span>
          ))}
        </p>
      )}
    </section>
  );
};

export default observer(AccountLogin);
